function parseDate(value) {
    if (!value) return null;
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function canApplyToSubvencio(grant, now = new Date()) {
    if (!grant || grant.status !== 'open') {
        return false;
    }

    const referenceDate = parseDate(now);
    const openAt = parseDate(grant.openAt);
    const closeAt = parseDate(grant.closeAt);

    if (openAt && referenceDate && referenceDate < openAt) {
        return false;
    }

    if (closeAt && referenceDate && referenceDate > closeAt) {
        return false;
    }

    return true;
}

export function getSubvencioApplyDisabledReason(grant, now = new Date()) {
    if (canApplyToSubvencio(grant, now)) {
        return null;
    }

    const referenceDate = parseDate(now);
    const openAt = parseDate(grant?.openAt);
    const closeAt = parseDate(grant?.closeAt);

    if (grant?.status === 'pending' || (openAt && referenceDate && referenceDate < openAt)) {
        return "El termini encara no s'ha obert";
    }

    if (grant?.status === 'closed' || (closeAt && referenceDate && referenceDate > closeAt)) {
        return "El termini d'aquesta subvenció ja s'ha acabat";
    }

    if (grant?.status === 'waiting') {
        return 'El termini encara no està disponible';
    }

    return "El termini d'aquesta subvenció no està confirmat";
}
